<template>
  <default-layout>
     <v-layout wrap>
         <v-flex xs12 mb-3>
             <donation-menu-bar></donation-menu-bar>
         </v-flex>
         <v-flex xs12 class="pt-5">
             <donation-table></donation-table>
         </v-flex>
     </v-layout>
  </default-layout>
</template>
<script>
import DonationMenuBar from './_components/donation_menu.vue'
import DonationTable from './_components/donation_table.vue'

export default {
  name: 'SonkoIndexPage',
  components: {
    DonationMenuBar,
    DonationTable
  },
  data () {
    return {
      
    }
  }
}
</script>
